// extracted by mini-css-extract-plugin
export default {"size":"40px","image":"Gfc8025","placeholder":"G14efdb"};